import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getProduct } from "../lib/api";
import { useCart } from "../context/CartContext";
import { Check, ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const { addItem } = useCart();
  const navigate = useNavigate();

  useEffect(() => { getProduct(id).then(setProduct).catch(() => navigate("/shop")); }, [id, navigate]);

  if (!product)
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#B0872A]" /></div>;

  return (
    <main className="pt-28 pb-28 min-h-screen relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <button data-testid="back-to-shop" onClick={() => navigate("/shop")} className="flex items-center gap-2 text-[#57515F] hover:text-[#1A1A1A] mb-10 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to shop
        </button>
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
          <div className="bg-[#E4E0EB] rounded-2xl overflow-hidden h-[70vh] max-h-[640px]">
            <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
          </div>
          <div className="flex flex-col justify-center">
            <p className="overline text-[#B0872A] mb-4">{product.category}</p>
            <h1 className="font-display text-5xl lg:text-6xl tracking-tight leading-none mb-3">{product.name}</h1>
            <p className="italic font-display text-2xl text-[#B0872A] mb-6">{product.tagline}</p>
            <p className="text-[#57515F] text-lg leading-relaxed mb-8">{product.description}</p>

            <ul className="space-y-3 mb-10">
              {product.benefits?.map((b) => (
                <li key={b} className="flex items-center gap-3 text-[#1A1A1A]">
                  <span className="w-5 h-5 rounded-full bg-[#2B2340] flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-white" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>

            <div className="flex items-center gap-6">
              <span className="font-display text-4xl">${product.price.toFixed(2)}</span>
              <div className="flex items-center gap-4 border border-[#DAD5E2] rounded-full px-5 py-2">
                <button data-testid="qty-dec" onClick={() => setQty((q) => Math.max(1, q - 1))}>−</button>
                <span data-testid="qty-value" className="w-6 text-center">{qty}</span>
                <button data-testid="qty-inc" onClick={() => setQty((q) => q + 1)}>+</button>
              </div>
            </div>

            <button
              data-testid="detail-add-to-cart"
              onClick={() => { addItem(product, qty); toast.success(`${product.name} added to cart`); }}
              className="btn-primary justify-center mt-8"
            >
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
